import React from 'react';
import { faCircleChevronDown,faCircleChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const HoursComponent = ({
    isOpen,
    closedAt,
    opensAt,
    showHours,
    hours,
    isVirtual,
    handleShowHours,
    scroll,
    active,
    barlow,
    colorWhite,
    colorBlack,
    htmlId,
  }) => {
    // Split hours to separate virtual hours section
    const virtualHoursMatch = hours.match(/__Virtual Hours__\s*(.*)/s);
    const virtualHours = virtualHoursMatch ? virtualHoursMatch[1] : null;
    const regularHours = virtualHoursMatch
      ? hours.replace(/__Virtual Hours__\s*(.*)/s, '')
      : hours;
  
    const formatHoursContent = (text) => {
      if (!text) return '';
      return text
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(line => line.length > 0)
        .map(line => `<div style="margin-bottom: 0.5rem">${line}</div>`)
        .join('');
    };
  
    return (
      <div
        onClick={handleShowHours}
        style={{
          position: htmlId.length > 0 ? '' : 'absolute',
          left: '0',
          top: '2.3rem',
        }}
      >
        <p
          className={
            (!scroll && !active ? colorWhite : colorBlack) +
            ' navbar-item ' +
            barlow
          }
          style={{ fontSize: '16px' }}
        >
          {isOpen ? 'Closes at ' + closedAt : 'Opens at ' + opensAt} &nbsp;
          <FontAwesomeIcon
            icon={showHours ? faCircleChevronUp : faCircleChevronDown}
            style={{
              color: isOpen ? (isVirtual ? 'yellow' : 'green') : 'red',
            }}
          />
        </p>
  
        {showHours && (
          <div
            className={
              (!scroll && !active ? colorBlack : colorBlack) +
              ' navbar-item ' +
              barlow
            }
            style={{
              background: !scroll && !active ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.7)',
              padding: '1rem',
              minWidth: '200px',
              display: 'flex',
              flexDirection: 'column',
              zIndex: 101
            }}
          >
            {virtualHours && (
              <>
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '0.75rem' }}>
                    Virtual Hours
                  </div>
                  <div 
                    dangerouslySetInnerHTML={{ 
                      __html: formatHoursContent(virtualHours) 
                    }} 
                  />
                </div>
                
                <div style={{ fontWeight: 'bold', marginBottom: '0.75rem' }}>
                  Office Hours
                </div>
              </>
            )}
            
            <div 
              dangerouslySetInnerHTML={{ 
                __html: formatHoursContent(regularHours) 
              }} 
            />
          </div>
        )}
      </div>
    );
  };

export default HoursComponent;